import _slicedToArray from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useMemo, useRef } from 'react';
import BigNumber from 'bignumber.js';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from "../../../../state/hooks";
import { useBestBuyPair, useBestBuyUserConfig } from "../../../../state/dex/hooks";
import { updateBestBuyUserConfig } from "../../../../state/dex/actions";
import { useTokenPrice } from "../../../../hooks/useTokenPrice";
import { StyledContainer, StyledInputWrapper, StyledIncreaseButtons, StyledIncreaseButton } from "./styled";
import { Row, StyledRowLabel, Input, InputHelpText, StyledReferWrapper, StyledReferLabel, StyledReferItem, Divider } from "../../styled";

var RateInput = () => {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var dispatch = useAppDispatch();

  var _useBestBuyPair = useBestBuyPair(),
      _useBestBuyPair2 = _slicedToArray(_useBestBuyPair, 2),
      inputToken = _useBestBuyPair2[0],
      outputToken = _useBestBuyPair2[1];

  var _useBestBuyUserConfig = useBestBuyUserConfig(),
      rate = _useBestBuyUserConfig.rate;

  var inputTokenPrice = useTokenPrice(inputToken === null || inputToken === void 0 ? void 0 : inputToken.address);
  var outputTokenPrice = useTokenPrice(outputToken === null || outputToken === void 0 ? void 0 : outputToken.address);
  var marketRate = useMemo(() => {
    if (!Number(inputTokenPrice) || !Number(outputTokenPrice)) return '1';
    return new BigNumber(outputTokenPrice).div(inputTokenPrice).toFixed(0);
  }, [inputTokenPrice, outputTokenPrice]);
  var rateRef = useRef(null);

  var onChange = e => {
    var value = e.target.value;
    if (value === '') return dispatch(updateBestBuyUserConfig({
      rate: ''
    }));
    var intValue = parseInt(value);

    if (!isNaN(intValue) && intValue >= 0) {
      dispatch(updateBestBuyUserConfig({
        rate: intValue.toString()
      }));
    }
  };

  var handleSetMarketRate = () => {
    dispatch(updateBestBuyUserConfig({
      rate: marketRate
    }));
  };

  var handleIncreaseRate = factor => {
    var newRate = new BigNumber(rate).multipliedBy(factor).toFixed(0);
    dispatch(updateBestBuyUserConfig({
      rate: newRate
    }));
  };

  useEffect(() => {
    if (!marketRate) return;
    dispatch(updateBestBuyUserConfig({
      rate: marketRate
    }));
  }, [outputTokenPrice]);
  return __jsx(Row, null, __jsx(StyledRowLabel, null, t('trigger_price_with_token', {
    token: outputToken === null || outputToken === void 0 ? void 0 : outputToken.symbol
  })), __jsx(StyledContainer, null, __jsx(StyledInputWrapper, {
    onClick: () => {
      var _rateRef$current;

      rateRef === null || rateRef === void 0 || (_rateRef$current = rateRef.current) === null || _rateRef$current === void 0 ? void 0 : _rateRef$current.focus();
    }
  }, __jsx(Input, {
    ref: rateRef,
    inputMode: "numeric",
    onChange: onChange,
    placeholder: "1800",
    value: rate,
    width: "".concat(Math.max(rate.length * 10, 40), "px")
  }), __jsx(InputHelpText, null, inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol), __jsx(StyledIncreaseButtons, null, __jsx(StyledIncreaseButton, {
    onClick: e => {
      handleIncreaseRate(0.95);
      e.stopPropagation();
    }
  }, "-5%"), __jsx(Divider, null), __jsx(StyledIncreaseButton, {
    onClick: e => {
      handleIncreaseRate(1.05);
      e.stopPropagation();
    }
  }, "+5%")))), __jsx(StyledReferWrapper, null, __jsx(StyledReferLabel, null, t('reference')), __jsx(StyledReferItem, {
    onClick: handleSetMarketRate
  }, t('market_price'))), __jsx(StyledReferWrapper, null, __jsx(StyledReferLabel, null, t('reference_tip'))));
};

export default RateInput;